// extracted by css-extract-rspack-plugin
export default {"imageSpacer":"_e009461e"};